import React from 'react';

type Props = {
  imageSrc: string,
  imageAlt: string,
  imageTitle?: string,
  imageWidth?: string,
  imageClass?: string,
  dataId?: string,
};

function IconImage(props: Props) {
  const {
    imageSrc,
    imageAlt,
    imageTitle,
    imageWidth,
    dataId,
    imageClass,
  } = props;

  return (
    <img
      className={imageClass}
      width={imageWidth}
      src={imageSrc}
      alt={imageAlt}
      title={imageTitle}
      data-automation-id={dataId && dataId}
    />
  );
}

IconImage.defaultProps = {
  imageTitle: null,
  imageWidth: null,
  imageClass: null,
  dataId: null,
};

export default IconImage;
